<h3 class="title configurator-title">{{ 'closet-doors-custom.environment.title' | translate }}</h3>
<div class="config-container shadow">
  <h4 class="title configurator-subtitle">{{ 'closet-doors-custom.environment.your-emplacement' | translate }}</h4>
  <div class="location-container">
    <div
      class="location-card"
      [ngClass]="{ active: isEmplacementSelected(location.id) }"
      *ngFor="let location of locations"
      (click)="selectLocation(location)">
      <ng-casto-img-loader [imgSrc]="baseImgURL + location.icon.path" [imgClass]="'location-img'"></ng-casto-img-loader>
      <p class="location-title">{{ location.name }}</p>
    </div>
    <ng-casto-loader *ngIf="locations === undefined"></ng-casto-loader>
  </div>

  <h4 class="title configurator-subtitle">{{ 'closet-doors-custom.environment.drawers' | translate }}</h4>
  <div class="d-flex">
    <span class="mr-2">{{ 'closet-doors-custom.environment.no' | translate }}</span>
    <div class="custom-control custom-switch">
      <input type="checkbox" [(ngModel)]="hasDrawers" class="custom-control-input" id="customSwitch2" />
      <label class="custom-control-label" for="customSwitch2">{{
        'closet-doors-custom.environment.yes' | translate
      }}</label>
    </div>
  </div>

  <h4 class="title configurator-subtitle mt-4" *ngIf="hasDrawers">
    {{ 'closet-doors-custom.environment.drawers-location' | translate }}
  </h4>
  <p class="custom-form-row form-checkbox" *ngIf="hasDrawers">
    <span>
      <input
        type="checkbox"
        id="input-signup-newsletter"
        [(ngModel)]="drawerLeft"
        (change)="onChangeDrawerLocation()" />
      <label for="input-signup-newsletter">{{ 'closet-doors-custom.environment.left' | translate }}</label>
    </span>

    <span>
      <input
        type="checkbox"
        id="input-signup-partners"
        [(ngModel)]="drawerCenter"
        (change)="onChangeDrawerLocation()" />
      <label for="input-signup-partners">{{ 'closet-doors-custom.environment.center' | translate }}</label>
    </span>

    <span>
      <input type="checkbox" id="input-signup-contact" [(ngModel)]="drawerRight" (change)="onChangeDrawerLocation()" />
      <label for="input-signup-contact">{{ 'closet-doors-custom.environment.right' | translate }}</label>
    </span>
  </p>
</div>
